import ui from './app/ui'
import session from './app/session'
import tasks from './app/tasks'

const modules = {
  ui, session, tasks
}

export default {
  namespaced: true,
  modules
}



// WEBPACK FOOTER //
// ./libs/@db2b/keystone/store/modules/app.js